import {createRouter, createWebHashHistory,createWebHistory} from 'vue-router'
import routes from './router'    //导入router目录下的router.js
import {getToken} from "@/store/cache";
import i18n from "@/locales/setupI18n";

const {t} = i18n.global;

const router = createRouter({
    // history: createWebHistory(),     //路由模式
    history:createWebHashHistory(),
    routes,
    // isAddDynamicMenuRoutes: false
})
router.beforeEach((to, from, next) => {
    document.title = t(to.meta.title) +' | '+t('main.b2');
    let token = getToken();
    console.log(to.path)
    let paths = ['/login','/details','/agreement-display','/demo']
    if(to.path != '/login' && to.path != '/details' && to.path != '/agreement-display' && to.path != '/demo'  && to.path != '/gateway'  && !token ){
        next('/login');
    }else {
        next()
    }
    // if(to.path !== '/login'){
    //     if(router.isAddDynamicMenuRoutes){
    //         next()
    //     }else {
    //         if(to.query.isAdmin == 2){
    //             router.removeRoute = router.addRoute(routeAdmin)
    //             router.isAddDynamicMenuRoutes = true;
    //             next({ ...to, replace: true })    //路由进行重定向放行
    //         }else {
    //             router.removeRoute = router.addRoute(route)
    //             router.isAddDynamicMenuRoutes = true;
    //             next({ ...to, replace: true })
    //         }
    //     }
    // }else {
    //     next();
    // }

});
export default router      //导出
